module.exports = __webpack_public_path__ + "static/images/social-copy.d22a7a2481935c92e45dd588789f2bfd.svg";